import {Component, OnInit} from '@angular/core';
import {ApiService} from '../services/api.service';
import {ActivatedRoute} from '@angular/router';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-qr-code',
  templateUrl: './qr-code.component.html',
  styleUrls: ['./qr-code.component.scss']
})
export class QrCodeComponent implements OnInit {
  imgQrcode = '';
  totalAmount = null;
  sellerName = null;
  overdue = null;
  id = null;
  baseURL = environment.apiURL;

  constructor(
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      this.id = params.id;
      this.getQrcodeData(this.id);
    });
  }

  getQrcodeData(id) {
    this.apiService.getQrcodeInvoicePayment(id).subscribe( response => {
      this.imgQrcode = this.baseURL + response['qr_code_file'];
      this.totalAmount = response['total_amount'];
      this.sellerName = response['seller_name'];
    });
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/qr-code/qr-code.component.ts